import type { ChangeEvent, FunctionComponent } from 'react';
import { useEffect, useState } from 'react';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import type { StyledComponent } from 'styled-components';
import styled, { css } from 'styled-components';
import type { IconType } from 'react-icons';
import type { TGenderOptions } from '../molecules';

type CustomDropdownProps = {
  hasError: boolean;
  theme: any;
  className?: string;
  id?: string;
  name: string;
  options: readonly TGenderOptions[];
  children?: React.ReactNode;
  defaultValue?: string;
  value?: string;
  onSubmit: any;
  // handleOnChange?: (e: ChangeEvent<HTMLSelectElement>) => void;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  ref?: React.Ref<any>;
  setValue: any;
  setFocus: any;
  errors: any;
  onBlur: any;
  trigger: any;
  resetField: any;
};

type DropdownLabelProps = {
  selectedOption: string;
  className?: string;
  children?: React.ReactNode;
  hasError: boolean;
  isOpen: boolean;
};
const DropdownLabelBase = ({
  selectedOption,
  className,
  isOpen
}: DropdownLabelProps) => (
  <div className={className}>
    <span>{selectedOption}</span>
    {isOpen ? <FaAngleUp /> : <FaAngleDown />}
  </div>
);

// type StyledSelectProps = {
//   className?: string;
//   children?: React.ReactNode;
//   hasError: boolean;
// };

const DropdownLabel = styled(DropdownLabelBase)<DropdownLabelProps>(
  ({ theme }) => css`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 32px;
    margin: ${theme.margins.default};
    color: ${theme.colors.main.primary};
    font-weight: 400;
    font-size: ${theme.fonts.subHeading};
    margin-top: auto;
    margin-bottom: auto;
  `
);

// TODO: type these properly
type SelectOptionProps = {
  text: string;
  Icon: StyledComponent<IconType, any, any>;
  children?: React.ReactNode;
  onClick: (e: any) => void;
};

const foo = (e: any, text: string, callbacK: any) => {
  callbacK(text);
};
const LabelWithIcon: FunctionComponent<SelectOptionProps> = ({
  text,
  Icon,
  onClick
}: SelectOptionProps) => {
  return (
    <div onClick={(e) => foo(e, text, onClick)}>
      {/* <div onClick={onClick}> */}
      <Icon /> {text}
    </div>
  );
};

const Dropdown = ({
  className,
  id,
  options,
  setValue,
  onBlur,
  trigger
}: // hasError,

CustomDropdownProps) => {
  const handleChange = (selectedValue: string) => {
    setSelectedOption(selectedValue);
  };

  const toggleDropdown = (event: any) => {
    // onBlur();
    toggleOpen(!isOpen);
    setWasOpened(true);
    // event.stopPropagation();
  };
  const initialState = 'Select Gender';
  const [selectedOption, setSelectedOption] = useState(initialState);
  const [isOpen, toggleOpen] = useState(false);
  const [wasOpened, setWasOpened] = useState(false);

  useEffect(() => {
    setValue('gender', selectedOption);
    if (wasOpened) {
      trigger('gender');
    }
  }, [selectedOption]);

  return (
    <div className={className} id={id} onClick={toggleDropdown}>
      <DropdownLabel selectedOption={selectedOption} hasError isOpen={isOpen} />
      <div
        className={
          isOpen ? 'dropdown dropdown-open' : 'dropdown dropdown-closed'
        }
      >
        {options.map((option) => (
          <div className="dropdown-option" key={option.text} onBlur={onBlur}>
            <LabelWithIcon
              text={option.text}
              Icon={option.icon}
              onClick={(e) => handleChange(e)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};
const CustomDropdown = styled(Dropdown)<CustomDropdownProps>(
  ({ theme, hasError }) => css`
    background-color: ${theme.colors.background};
    border: ${theme.borders.form};
    border-radius: 4px;
    height: 32px;
    padding: 0 16px;
    margin: 8px;
    color: ${theme.colors.highlight};
    font-weight: 400;
    font-size: 16px;
    outline: 1px solid
      ${hasError ? theme.colors.error : theme.colors.main.primary};
    cursor: pointer;
    z-index: ${theme.zIndexes.modalForeground};

    .dropdown {
      background-color: ${theme.colors.nav};
      border: ${theme.borders.form};
      background-color: ${theme.colors.nav};
      color: ${theme.colors.main.primary};
      transition: all 0.3s ease-out;

      /* Hiding */
      opacity: 0;
      pointer-events: none;
    }
    .dropdown-option {
      justify-content: start;
      border: ${theme.borders.normal};
      padding: ${theme.paddings.default};
      transition: all 0.3s ease-out;
    }
    .dropdown-option:nth-child(2n -1) {
      border-left-color: ${theme.colors.main};
    }

    .dropdown-option {
      &:hover {
        color: ${theme.colors.ctaText};
        background-color: ${theme.colors.ctaButton};
        // text-align: center;
        border-radius: ${theme.borderRadii.nonRounded};
        font-size: 20px;
      }
    }
    .dropdown-open {
      opacity: 1;
      pointer-events: auto;
    }
  `
);

export { CustomDropdown };
